import { useState } from 'react';
import { profileService } from 'shared/services/profileService';
import { useQueryClient } from 'react-query';
import { PROFILE_LINKS_QUERY_STRING } from 'shared/constants/QUERY_STRING';
import { IProfileLink } from 'shared/interfaces/IProfile';
import { CheckProps } from 'pages/MyLinks/types';
const { updateProfile } = profileService();

type SelectedBoxProps = 'primary' | 'email' | 'phone_number' | string | null;

export const useProfileListCheckbox = (
  profileLink: IProfileLink,
  selectedPrimary: string | null,
  setSelectedPrimary: any,
) => {
  const queryClient = useQueryClient();
  const { primary_link, representation_type, shareable_info } = profileLink;
  const [shareableInfo, setShareableInfo] = useState(shareable_info || []);
  const { mutate, isLoading: isUpdating } = updateProfile();
  const [includeEmail, setIncludeEmail] = useState(shareable_info?.includes('email') || false);
  const [includePhone, setIncludePhone] = useState(shareable_info?.includes('phone_number') || false);
  const [selectedBox, setSelectedBox] = useState<SelectedBoxProps>('');
  const isRepresented = representation_type === 'agency_representation' ? true : false;

  const handlePrimary = () => {
    setSelectedBox('primary');
    mutate(
      {
        profileId: profileLink?.id,
        payload: {
          primary_link: !primary_link,
        },
      },
      {
        onSuccess: async () => {
          await queryClient.invalidateQueries([PROFILE_LINKS_QUERY_STRING.PROFILE_LIST]);
        },
      },
    );

    if (selectedPrimary === profileLink?.id) {
      setSelectedPrimary('');
    } else {
      setSelectedPrimary(profileLink?.id);
    }
  };

  const handleInclude = async (key: 'email' | 'phone_number') => {
    if (representation_type === 'agency_representation') return;
    setSelectedBox(key);
    let newShareableInfo: string[] = [];
    const isValid = shareableInfo.includes(key);

    if (isValid) {
      newShareableInfo = shareableInfo?.filter((info) => info !== key);
    } else {
      newShareableInfo = [...shareableInfo, key];
    }
    mutate(
      {
        profileId: profileLink?.id,
        payload: {
          shareable_info: newShareableInfo,
        },
      },
      {
        onSuccess: async () => {
          if (key === 'email') {
            setIncludeEmail((prev) => !prev);
          } else {
            setIncludePhone((prev) => !prev);
          }
          setShareableInfo(newShareableInfo);
          await queryClient.invalidateQueries([PROFILE_LINKS_QUERY_STRING.PROFILE_LIST]);
        },
      },
    );
  };

  const CheckBoxList: CheckProps[] = [
    {
      name: selectedPrimary === profileLink?.id ? 'Primary' : 'Make Primary',
      key: 'primary',
      onClick: () => handlePrimary(),
      checked: selectedPrimary === profileLink?.id,
    },
    {
      name: 'Include my Email',
      key: 'email',
      onClick: () => handleInclude('email'),
      checked: includeEmail,
    },
    {
      name: 'Include my Phone Number',
      key: 'phone_number',
      onClick: () => handleInclude('phone_number'),
      checked: includePhone,
    },
  ];

  return { CheckBoxList, isRepresented, isUpdating, selectedBox };
};
